// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15sN5","col":"styles_col__2gu9c"};